import styled from 'styled-components';
import { THEME } from '../../../themes';
import {
  Body1Font,
  ButtonFont,
  Title2Font,
  Title3Font,
} from '../../../themes/fonts';
import Dialog from '../base-dialog/base-dialog.component';

export const StyledBody = styled(Dialog.Body)`
  padding: 0;
`;

export const Container = styled.div`
  display: flex;
  gap: ${THEME.SPACING.LOOSE};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${THEME.SPACING.LOOSE};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
  align-items: center;
  justify-content: center;
  
`;

export const DialogHeaderTitle = styled.div`
  ${ButtonFont};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Subtitle = styled.div`
  ${Title3Font};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Title = styled.div`
  ${Title2Font};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Description = styled.div`
  ${Body1Font};
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_A};
  text-align: center;
  line-height: 1.5;
  white-space: pre-line;
`;
